<template>
  <div>
    <list
      row-key="ClassId"
      ref="list"
      unit="出入库类别"
      :page="page"
      :show-checkbox="showCheckbox"
      :get-data-func="getDataFunc"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>

      <template slot="table">
        <el-table-column
          prop="Sn"
          label="序号"
          min-width="80px"
          align="left"
        />
        <el-table-column
          prop="ClassNo"
          label="出入库类别编码"
          min-width="120px"
          align="left"
        />
        <el-table-column
          prop="ClassName"
          label="出入库类别名称"
          min-width="120px"
          align="left"
        />

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    IsSelect: {
      type: Boolean,
      default: false,
    },
    showType: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/ba/class").default,
    };
  },
  methods: {
    getDataFunc(params = {}) {
      return new Promise((resolve) => {
        this.api.list({ ...params, ClassType: 16 }).then((res) => {
          resolve({ ...res, Data: res.Data.filter((i) => i.Pid !== 0) });
        });
      });
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
